import { __rest } from "tslib";
import React, { useState, useContext } from 'react';
import RCTour from '@rc-component/tour';
import classNames from 'classnames';
import { ConfigContext } from '../config-provider';
import TourPenal from './panelReander';
import getPlacements from '../_util/placements';
import useBuriedPoint from '../_util/hooks/useBuriedPoint';
const Tour = (props) => {
    var _a;
    const { prefixCls: customizePrefixCls, rootClassName, current, defaultCurrent, animated, steps = [], type, indicatorsRender, onChange, getPopupContainer, showClose = true } = props, restProps = __rest(props, ["prefixCls", "rootClassName", "current", "defaultCurrent", "animated", "steps", "type", "indicatorsRender", "onChange", "getPopupContainer", "showClose"]);
    const { getPrefixCls } = useContext(ConfigContext);
    const prefixCls = getPrefixCls('tour', customizePrefixCls);
    const [innerCurrent, setInnerCurrent] = useState(current !== null && current !== void 0 ? current : defaultCurrent);
    const innerType = typeof innerCurrent === 'number' ? (_a = steps[innerCurrent]) === null || _a === void 0 ? void 0 : _a.type : type;
    const mergedType = innerType !== null && innerType !== void 0 ? innerType : type;
    const tourClassName = classNames({
        [`${prefixCls}-primary`]: mergedType === 'primary',
    }, rootClassName);
    const builtinPlacements = getPlacements({
        arrowPointAtCenter: true,
        autoAdjustOverflow: true,
    });
    useBuriedPoint('Tour');
    const renderPanel = (props, current) => {
        return (React.createElement(TourPenal, { stepsProps: props, current: current, showClose: showClose, type: type, indicatorsRender: indicatorsRender }));
    };
    const onStepsChange = (stepsCurrent) => {
        var _a;
        setInnerCurrent(stepsCurrent);
        (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, stepsCurrent);
    };
    return (React.createElement(RCTour, Object.assign({}, restProps, { prefixCls: prefixCls, rootClassName: tourClassName, current: current, defaultCurrent: defaultCurrent, animated: animated, steps: steps, onChange: onStepsChange, renderPanel: renderPanel, builtinPlacements: builtinPlacements, 
        // @ts-ignore
        getPopupContainer: getPopupContainer })));
};
Tour.defaultProps = {
    defaultCurrent: 0,
    mask: true,
    animated: false,
    zIndex: 1001,
    type: 'default',
};
if (process.env.NODE_ENV !== 'production') {
    Tour.displayName = 'Tour';
}
export default Tour;
